import { withFormik } from "formik";
import React from "react";

import PageCard from "../../../General/PageCard";
import {
  buildValidationSchema,
  bundleFormContext,
  handleSubmit
} from "../FormContent/formHelpers";
import {
  FieldSection,
  OrganizationNameField,
  EmailField,
  PasswordField,
  AgreesToTermsField
} from "../FormContent/RegistrationFormFields";
import RegistrationFormFooter from "../FormContent/RegistrationFormFooter";
import RFIFeaturesGraphic from "../FormContent/RFIFeaturesGraphic";

import TermsSection from "../FormContent/TermsSection";

export function CommunityGreeting() {
  return (
    <div style={{ width: "90%", padding: 24 }}>
      Welcome to the RecruitiFi platform. You are applying to be part of the
      {' '}
      {" "}
      <span className="bold">RecruitiFi Community</span>
      . Please create your login
      so you can begin the application process. If accepted, you will be invited
      to work on jobs suited to your skillset.
    </div>
  );
}

function CommunityRegistrationForm(props) {
  const formContextProps = bundleFormContext(props);

  return (
    <PageCard
      title="Agency Application"
      footerVisible
      footer={<RegistrationFormFooter {...formContextProps} />}
      contentPadding={24}
    >
      <RFIFeaturesGraphic />
      <CommunityGreeting />
      <TermsSection />
      <FieldSection>
        {[
          OrganizationNameField,
          EmailField,
          PasswordField,
          AgreesToTermsField
        ].map(fieldKlass => React.createElement(fieldKlass, formContextProps))}
      </FieldSection>
    </PageCard>
  );
}

const CommunityRegistrationFormWithFormik = withFormik({
  handleSubmit,
  mapPropsToValues: () => ({
    organization_name: "",
    email: "",
    password: "",
    agrees_to_terms: false
  }),
  validationSchema: buildValidationSchema([
    "organization_name",
    "email",
    "password",
    "agrees_to_terms"
  ])
})(CommunityRegistrationForm);

export default CommunityRegistrationFormWithFormik;
